import request from "../utils/request";
//import { PAGE_SIZE } from '../../../constants';
import { autoAssign } from "../utils/tcAssignmentDistribution";
import { getBackendURL } from "../utils/common";

export const getUploadAction = () => {
  const TC_URL = getBackendURL();
  const apiKey = window.API_KEY;
  return `${TC_URL}/api/upload.json?API_KEY=${apiKey}`;
};

export function login({ email, password }) {
  // 1. get backend URL
  const TC_URL = getBackendURL();

  let options = {
    method: "POST",
    body: JSON.stringify({
      data: {
        User: {
          email: email,
          password: password
        }
      }
    })
  };

  return request(`${TC_URL}/users/login.json`, options);
}

export function fetch({
  action,
  suffix = "",
  projectId = false,
  options = {}
  //apiKey = false
}) {
  // 1. get backend URL
  const TC_URL = getBackendURL();

  // 2. get api KEY?
  //console.log("api_key", window.API_KEY);
  const apiKey = window.API_KEY;
  if (apiKey) {
    suffix = `?API_KEY=${apiKey}${suffix}`;
  } else {
    suffix = `?${suffix}`;
  }

  let prefix = "";
  if (projectId) prefix = `/project/${projectId}`;
  //return request(`${TC_URL}${prefix}${action}.json`, options);
  return request(`${TC_URL}${prefix}${action}.json${suffix}`, options);
}

export function post({ action, options, suffix = "" }) {
  options = { ...options, method: "POST" };
  options.body = JSON.stringify({ data: options.body });
  //console.log("here");
  return fetch({ action, suffix, options });
}

export function createExecution(options) {
  const action = "";
  return post({
    action: "/executions/add",
    options: { body: { Execution: options } }
  });
}

export async function selfAssignExecution({
  testCaseSelection,
  executor,
  assignmentMode,
  teamMates,
  executionID
}) {
  let assignMap = {};
  // resolve test case selection
  if (testCaseSelection.testSuite) {
    assignMap["User_" + sessionUser.id] = {
      suites: [testCaseSelection.testSuite]
    };
  }

  const action = "";

  return post({
    action: "/executions/assignTest/" + executionID,
    options: { body: { Execution: { assign_map: assignMap } } }
  });
}

export async function assignExecution({ assignMap, executionID }) {
  //let assignMap = {};
  // resolve test case selection

  //assignMap = await autoAssign({ testCaseSelection, teamMates });

  const action = "";

  return post({
    action: "/executions/assignTest/" + executionID,
    options: { body: { Execution: { assign_map: assignMap } } }
  });
}

/*
export function remove(id) {
  return request(`/api/users/${id}`, {
    method: 'DELETE',
  });
}

export function patch(id, values) {
  return request(`/api/users/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(values),
  });
}

export function create(values) {
  return request('/api/users', {
    method: 'POST',
    body: JSON.stringify(values),
  });
}*/
